export const Snowflake = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="13" y="13" width="6" height="6" stroke="currentColor" stroke-width="2"/>
<path d="M27 5L19 13" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M28 11H21V4" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M16 13V8" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M27 27L19 19" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M21 28L21 21L28 21" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M19 16L24 16" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M5 27L13 19" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M4 21H11V28" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M16 19V24" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M5 5L13 13" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M11 4L11 11L4 11" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M13 16L8 16" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
